import { CloseRoundedIcon, KeyboardArrowDownRoundedIcon } from '../../icons';
import type { OptionSelectionProps } from '../../Inputs/types';
import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiAutocomplete: {
      defaultProps: {
        clearIcon: <CloseRoundedIcon />,
        popupIcon: <KeyboardArrowDownRoundedIcon />,
        loadingText: 'กำลังโหลด...',
        noOptionsText: 'ไม่มีผลลัพธ์',
        openOnFocus: true,
        includeInputInList: true,
        limitTags: 2,
        ChipProps: { size: 'small' },
        isOptionEqualToValue: (option: OptionSelectionProps, { value }: OptionSelectionProps) =>
          value === option.value,
      },
      styleOverrides: {
        inputRoot: ({ theme: { unstable_sx: sx } }) =>
          sx({
            pl: 2,
            '.MuiOutlinedInput-input': {
              p: 0,
              height: '24px',
              minHeight: '24px',
            },
            '.MuiChip-root': {
              /*
            if use default `height` of chip small `24px`, size of input will not be `44px`
            and must have `my` to support case multiple value
            */
              height: 22,
              my: 0.125,
              mx: 0.375,
              fontSize: 14,
              '~.MuiOutlinedInput-input': {
                ml: 0.75,
              },
            },
          }),
        tag: ({ theme: { unstable_sx: sx } }) => sx({ mt: 0.125, mb: 0, ml: 0.375, mr: 0 }),
        clearIndicator: ({ theme: { unstable_sx: sx } }) => sx({ height: 28, width: 28 }),
        popupIndicator: ({ theme: { unstable_sx: sx } }) => sx({ height: 24, width: 24 }),
        paper: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({
            borderRadius: 2,
            borderStyle: 'solid',
            borderWidth: 0.5,
            borderColor: theme.palette.grey[200],
            boxShadow: '0px 4px 8px rgba(52, 58, 64, 0.1)',
          }),
        listbox: ({ theme: { unstable_sx: sx } }) => sx({ p: 1 }),
        option: ({ theme: { unstable_sx: sx } }) =>
          sx({
            borderRadius: 1.5,
            py: 0.75,
            px: 1,
          }),
      },
    },
  },
});

export default theme.components;
